import api from '../config/api';
import { isApiEnabled } from '../config/appConfig';
import { getApiData, parseApiError } from './apiUtils';

const STORAGE_KEY = 'blf_comments_about';
const PAGE_KEY = 'about';

const sampleComments = [
  {
    id: 1,
    pagina: PAGE_KEY,
    nombre_usuario: 'Juan Pablo Araque',
    avatar_url: null,
    texto:
      'Esta página web es increíblemente útil para las terapias de mis hijos. Como padre, aprecio mucho la organización y la cantidad de recursos disponibles para apoyar su desarrollo. ¡Gracias por crear un espacio tan valioso!',
    estado: 'aprobado',
    creado_en: '2025-08-08T10:00:00.000Z',
  },
  {
    id: 2,
    pagina: PAGE_KEY,
    nombre_usuario: 'Mavi Mantilla',
    avatar_url: null,
    texto: 'Es una joya para los que queremos colaborar con esta grandiosa misión.',
    estado: 'aprobado',
    creado_en: '2024-11-08T14:30:00.000Z',
  },
  {
    id: 3,
    pagina: PAGE_KEY,
    nombre_usuario: 'Mavi Mantilla',
    avatar_url: null,
    texto:
      'La información está muy bien organizada y es fácil de encontrar. Los detalles sobre las terapias son muy claros, lo que me ayuda a entender mejor cómo apoyar a mi hijo. ¡Gran trabajo en la página web!',
    estado: 'aprobado',
    creado_en: '2024-11-08T15:00:00.000Z',
  },
];

const readStoredComments = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch (error) {
    return null;
  }
};

const writeStoredComments = (comments) => {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(comments));
};

const getInitialComments = () => {
  const stored = readStoredComments();
  return stored && stored.length ? stored : sampleComments;
};

const fetchCommentsLocal = (pagina = PAGE_KEY) => {
  const comments = getInitialComments()
    .filter((item) => item.pagina === pagina && item.estado === 'aprobado')
    .sort((a, b) => new Date(b.creado_en) - new Date(a.creado_en));

  return Promise.resolve(comments);
};

const submitCommentLocal = ({ pagina = PAGE_KEY, nombre_usuario, texto }) => {
  const trimmedText = (texto || '').trim();

  if (!trimmedText) {
    return Promise.reject(new Error('El comentario es obligatorio.'));
  }

  const comments = getInitialComments();
  const nextComment = {
    id: Date.now(),
    pagina,
    nombre_usuario: (nombre_usuario || '').trim() || 'Visitante',
    avatar_url: null,
    texto: trimmedText,
    estado: 'pendiente',
    creado_en: new Date().toISOString(),
  };

  const updated = [nextComment, ...comments];
  writeStoredComments(updated);

  return Promise.resolve(nextComment);
};

export const fetchComments = (pagina = PAGE_KEY) => {
  if (!isApiEnabled()) {
    return fetchCommentsLocal(pagina);
  }

  return api
    .get('/comentarios_listar.php', { params: { pagina } })
    .then((response) => getApiData(response, 'No se pudieron cargar los comentarios.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const submitComment = ({ pagina = PAGE_KEY, nombre_usuario, texto }) => {
  if (!isApiEnabled()) {
    return submitCommentLocal({ pagina, nombre_usuario, texto });
  }

  return api
    .post('/comentarios_crear.php', {
      pagina,
      nombre_usuario,
      texto,
    })
    .then((response) => getApiData(response, 'No se pudo enviar el comentario.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const formatCommentDate = (isoDate) => {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const months = [
    'Ene.',
    'Feb.',
    'Mar.',
    'Abr.',
    'May.',
    'Jun.',
    'Jul.',
    'Ago.',
    'Sep.',
    'Oct.',
    'Nov.',
    'Dic.',
  ];

  return `${date.getDate()} de ${months[date.getMonth()]} ${date.getFullYear()}`;
};

export const getAvatarInitials = (name) => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) {
    return '?';
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};
